;
(function () {
	// helpers
	var regExp = function (name) {
		return new RegExp('(^| )' + name + '( |$)');
	};
	var forEach = function (list, fn, scope) {
		for (var i = 0; i < list.length; i++) {
			fn.call(scope, list[i]);
		}
	};

	// class list object with basic methods
	function ClassList(element) {
		this.element = element;
	}

	ClassList.prototype = {
		add: function () {
			forEach(arguments, function (name) {
				if (!this.contains(name)) {
					this.element.className += ' ' + name;
				}
			}, this);
		},
		remove: function () {
			forEach(arguments, function (name) {
				this.element.className =
					this.element.className.replace(regExp(name), '');
			}, this);
		},
		toggle: function (name) {
			return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
		},
		contains: function (name) {
			return regExp(name).test(this.element.className);
		},
		// bonus..
		replace: function (oldName, newName) {
			this.remove(oldName), this.add(newName);
		}
	};

	// IE8/9, Safari
	if (!('classList' in Element.prototype)) {
		Object.defineProperty(Element.prototype, 'classList', {
			get: function () {
				return new ClassList(this);
			}
		});
	}

	// replace() support for others
	if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
		DOMTokenList.prototype.replace = ClassList.prototype.replace;
	}
})();


/* polyfill for IE on "closest" */
(function (ELEMENT) {
	ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
	ELEMENT.closest = ELEMENT.closest || function closest(selector) {
		if (!this) return null;
		if (this.matches(selector)) return this;
		if (!this.parentElement) {
			return null
		} else return this.parentElement.closest(selector)
	};
}(Element.prototype));

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
	String.prototype.padStart = function padStart(targetLength, padString) {
		targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
		padString = String(padString || ' ');
		if (this.length > targetLength) {
			return String(this);
		} else {
			targetLength = targetLength - this.length;
			if (targetLength > padString.length) {
				padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
			}
			return padString.slice(0, targetLength) + String(this);
		}
	};
}

// BroadcastChannel polyfill ----------> https://gist.github.com/inexorabletash/52f437d1451d12145264
(function (global) {
	var channels = [];

	function BroadcastChannel(channel) {
		var $this = this;
		channel = String(channel);

		var id = '$BroadcastChannel$' + channel + '$';

		channels[id] = channels[id] || [];
		channels[id].push(this);

		this._name = channel;
		this._id = id;
		this._closed = false;

		try {
			this._mc = new MessageChannel();
		} catch (error) {
			console.error("MessageChannel Error", error);

			function createMocMessageChannel() {
				function createMocPort() {
					return {
						start: function () { },
						close: function () { },
						removeEventListener: function () { },
						postMessage: function () { },
					}
				}
				return {
					port1: createMocPort(),
					port2: createMocPort()
				}
			}
			this._mc = createMocMessageChannel();
		}

		this._mc.port1.start();
		this._mc.port2.start();


		global.addEventListener('storage', function (e) {
			if (e.storageArea !== global.localStorage) return;
			if (e.newValue === null) return;
			// постоянно ошибки сыпятся в консоли, хуже не будет
			if (e.newValue === '') return;
			if (e.key.substring(0, id.length) !== id) return;
			try {
				var data = JSON.parse(e.newValue);
				$this._mc.port2.postMessage(data);
			} catch (e) {
				console.error('storage newValue parse error', e);
			}
		});
	}

	BroadcastChannel.prototype = {
		// BroadcastChannel API
		get name() {
			return this._name;
		},
		postMessage: function (message) {
			var $this = this;
			if (this._closed) {
				var e = new Error();
				e.name = 'InvalidStateError';
				throw e;
			}
			var value = JSON.stringify(message);

			// Broadcast to other contexts via storage events...
			var key = this._id + String(Date.now()) + '$' + String(Math.random());
			global.localStorage.setItem(key, value);
			setTimeout(function () {
				global.localStorage.removeItem(key);
			}, 500);

			// Broadcast to current context via ports
			channels[this._id].forEach(function (bc) {
				if (bc === $this) return;
				bc._mc.port2.postMessage(JSON.parse(value));
			});
		},
		close: function () {
			if (this._closed) return;
			this._closed = true;
			this._mc.port1.close();
			this._mc.port2.close();

			var index = channels[this._id].indexOf(this);
			channels[this._id].splice(index, 1);
		},

		// EventTarget API
		get onmessage() {
			return this._mc.port1.onmessage;
		},
		set onmessage(value) {
			this._mc.port1.onmessage = value;
		},
		addEventListener: function (type, listener /*, useCapture*/) {
			return this._mc.port1.addEventListener.apply(this._mc.port1, arguments);
		},
		removeEventListener: function (type, listener /*, useCapture*/) {
			return this._mc.port1.removeEventListener.apply(this._mc.port1, arguments);
		},
		dispatchEvent: function (event) {
			return this._mc.port1.dispatchEvent.apply(this._mc.port1, arguments);
		}
	};

	global.BroadcastChannel = global.BroadcastChannel || BroadcastChannel;
}(self));
